var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwitchRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_29_35",
    "data-name": "Component 29 \\u2013 35",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 18,
    viewBox: "0 0 48 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4512",
    "data-name": "Rectangle 4512",
    width: 48,
    height: 18,
    rx: 9,
    fill: "#ff003b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4513",
    "data-name": "Rectangle 4513",
    transform: "translate(1 1)",
    fill: "#ff003b",
    stroke: "#fafbfa",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchRed);
export default __webpack_public_path__ + "static/media/switch-red.476da025c72fad269ecb9eb7fb8544c8.svg";
export { ForwardRef as ReactComponent };